/**
 * @desc 根据会员id获取企业认证详情
 */
import { AuditEnterpriseEntity } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuditEnterpriseDetailByMemberIdParameter = {
  memberId?: string
}

const method = 'GET'
const url = '/auth/audit/getEnterpriseByMemberId'

export const queryAuditEnterpriseDetailByMemberIdApi = (
  params?: QueryAuditEnterpriseDetailByMemberIdParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuditEnterpriseEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryAuditEnterpriseDetailByMemberIdApi.method = method
queryAuditEnterpriseDetailByMemberIdApi.url = url
